import * as React from "react";
import Select from "react-select";
import AddressValidator from "./AddressValidator";
import stateOptions from "./forms/data/stateOptions";

const { Row, Col, FormGroup, ControlLabel } = require("react-bootstrap");

interface AddressFieldsWithValidationProps {
  callback: Function;
  saveAddress?: Function;
  labelValue?: string;
  hint?: string;
  skipValidation?: boolean;
  address_line1?: string;
  address_line2?: string;
  city?: string;
  state?: string;
  postal_code?: string;
  onFocus?: React.FocusEventHandler<{}>;
  onBlur?: React.FocusEventHandler<{}>;
  disabled?: boolean;
  autoComplete?: string;
}

class AddressFieldsWithValidation extends React.Component<AddressFieldsWithValidationProps, any> {
  constructor(props: AddressFieldsWithValidationProps) {
    super(props);
    this.state = {
      address_line1: props.address_line1 || "",
      address_line2: props.address_line2 || "",
      city: props.city || "",
      state: props.state || "",
      postal_code: props.postal_code || "",
    };
    this.stateOptions = stateOptions;
  }

  handleOnChange = e => {
    const newState = {
      [e.target.name]: e.target.type === "checkbox" ? e.target.checked : e.target.value,
    };
    this.updateState(newState);
  };

  handleStateChange = e => {
    this.updateState({ state: (e && e.value) || "" });
  };

  updateState = newState => {
    this.setState(newState, () => {
      this.props.callback(this.state);
    });
  };

  saveAddress = newState => {
    this.updateState(newState);
    if (this.props.saveAddress) {
      this.props.saveAddress(newState);
    }
  };

  stateOptions: Object;

  render() {
    const {
      labelValue,
      hint,
      onFocus,
      onBlur,
      skipValidation,
      disabled,
      autoComplete,
    } = this.props;
    const { address_line1, address_line2, city, state, postal_code } = this.state;

    const sharedProps = {
      onFocus: onFocus || null,
      onBlur: onBlur || null,
      onChange: this.handleOnChange.bind(this),
    };

    return (
      <FormGroup>
        <ControlLabel>{labelValue}</ControlLabel>
        {hint && <span className="help-block">{hint}</span>}
        <Row>
          <Col md={3}>
            <input
              className="form-control"
              name="address_line1"
              placeholder="Address Line 1"
              value={address_line1}
              disabled={!!disabled}
              autoComplete={autoComplete || "off"}
              {...sharedProps}
            />
          </Col>
        </Row>
        <Row>
          <Col md={3}>
            <input
              className="form-control"
              name="address_line2"
              placeholder="Address Line 2"
              value={address_line2}
              disabled={!!disabled}
              autoComplete={autoComplete || "off"}
              {...sharedProps}
            />
          </Col>
        </Row>
        <Row>
          <Col md={3}>
            <input
              className="form-control"
              name="city"
              placeholder="City"
              value={city}
              disabled={!!disabled}
              autoComplete={autoComplete || "off"}
              {...sharedProps}
            />
          </Col>
          <Col id="select-state" md={2}>
            <Select
              name="state"
              className="form__state"
              placeholder="State"
              options={this.stateOptions}
              value={state}
              onFocus={onFocus}
              onBlur={onBlur}
              onChange={this.handleStateChange}
              disabled={!!disabled}
              autoComplete={autoComplete || "off"}
            />
          </Col>
          <Col md={2}>
            <input
              className="form-control form__zip"
              name="postal_code"
              placeholder="Zip Code"
              value={postal_code}
              disabled={!!disabled}
              autoComplete={autoComplete || "off"}
              {...sharedProps}
            />
          </Col>
        </Row>
        {!skipValidation && (
          <AddressValidator
            address_line1={address_line1}
            address_line2={address_line2}
            city={city}
            state={state}
            postal_code={postal_code}
            callback={this.saveAddress}
          />
        )}
      </FormGroup>
    );
  }
}

export default AddressFieldsWithValidation;
